import "core-js/modules/es6.regexp.split";
import { extractCategoryHash } from '~/helpers/extract-helper';
export default {
  type: 'generic',
  aliases: ['decoration', 'event', 'generic', 'meubles', 'meubles-decoration', 'mobilier-decoration-jardin', 'nouveautes', 'page', 'style-inspiration', 'so-me-canape', 'rendez-vous-en-magasin', 'tendances-deco'],
  slices: [{
    name: 'generic_organism',
    path: 'Generic/GenericOrganism.vue'
  }, {
    name: 'game_form',
    path: 'Generic/LotteryForm.vue'
  }, {
    name: 'page_header',
    path: 'Generic/PageHeader.vue'
  }, {
    name: 'intro_image_cta',
    path: 'Generic/IntroImageCta.vue'
  }, {
    name: 'intro_title_cta',
    path: 'Generic/IntroTitleCta.vue'
  }, {
    name: 'block_order',
    path: 'Generic/BlockOrder.vue'
  }, {
    name: 'landing_app',
    path: 'Generic/LandingApp.vue'
  }, {
    name: 'lookbook_push',
    path: 'Generic/LookbookPush.vue'
  }, // article slices
  {
    name: 'products_carousel_eb',
    path: 'Article/ArticleCarousel.vue'
  }, {
    name: 'article_paragraph',
    path: 'Article/ArticleParagraph.vue'
  }, {
    name: 'article_quote',
    path: 'Article/ArticleQuote.vue'
  }, {
    name: 'article_image',
    path: 'Article/ArticleImage.vue'
  }, {
    name: 'article_chips',
    path: 'Global/GlobalChips.vue'
  }, {
    name: 'article_products',
    path: 'Article/ArticleProducts.vue',
    additional: {
      query: 'products',

      handler(arg) {
        return {
          references: arg.items.map(e => e.reference)
        };
      }

    }
  }, {
    name: 'article_dispatch',
    path: 'Article/ArticleDispatch.vue'
  }, // trend slices
  {
    name: 'trend_header',
    path: 'Trend/TrendHeader.vue'
  }, {
    name: 'trend_theme',
    path: 'Trend/TrendTheme.vue'
  }, {
    name: 'trend_description',
    path: 'Trend/TrendDescription.vue'
  }, {
    name: 'trend_information',
    path: 'Trend/TrendInformation.vue'
  }, {
    name: 'trend_complementary',
    path: 'Trend/TrendComplementary.vue'
  }, {
    name: 'trend_video',
    path: 'Trend/TrendVideo.vue'
  }, {
    name: 'trend_footer',
    path: 'Trend/TrendFooter.vue'
  }, {
    name: 'trend_additional',
    path: 'Trend/TrendAdditional.vue'
  }, {
    name: 'global_quote_portrait',
    path: 'Global/GlobalQuotePortrait.vue'
  }, {
    name: 'global_footer',
    path: 'Global/GlobalFooter.vue'
  }, {
    name: 'trend_dispatch',
    path: 'Trend/TrendDispatch.vue'
  }, {
    name: 'global_chips',
    path: 'Global/GlobalChips.vue'
  }, // collection
  {
    name: 'customize_product',
    path: 'Generic/CustomizeProduct.vue',
    additional: {
      query: 'customized',

      handler(arg) {
        const primary = arg.primary.primary_references.split(',');
        const secondary = arg.primary.secondary_references.split(',');
        return {
          primary,
          secondary
        };
      }

    }
  }, {
    name: 'collection_video_header',
    path: 'Collection/CollectionVideoHeader.vue'
  }, {
    name: 'collection_products',
    path: 'Collection/CollectionProducts.vue'
  }, {
    name: 'collection_products_complementary',
    path: 'Collection/CollectionProductsComplementary.vue'
  }, {
    name: 'collection_big_inspiration',
    path: 'Collection/CollectionBigInspiration.vue'
  }, {
    name: 'collection_header_paragraph',
    path: 'Collection/CollectionHeaderParagraph.vue'
  }, {
    name: 'collection_inspiration',
    path: 'Collection/CollectionInspiration.vue'
  }, {
    name: 'collection_battle',
    path: 'Collection/CollectionBattle.vue'
  }, {
    name: 'collection_olapic',
    path: 'Collection/CollectionOlapic.vue'
  }, // custom slices
  {
    name: 'custom_loan',
    path: 'Custom/CustomLoan.vue'
  }, {
    name: 'custom_text',
    path: 'Custom/CustomText.vue'
  }, {
    name: 'custom_image',
    path: 'Custom/CustomImage.vue'
  }, {
    name: 'custom_button',
    path: 'Custom/CustomButton.vue'
  }, // landing slices
  // not found
  {
    name: 'landing_header',
    path: 'Landing/LandingHeader.vue'
  }, {
    name: 'landing_header_with_image',
    path: 'Landing/LandingHeaderWithImage.vue'
  }, {
    name: 'landing_image_text',
    path: 'Landing/LandingImageText.vue'
  }, {
    name: 'landing_video_text',
    path: 'Landing/LandingVideoText.vue'
  }, {
    name: 'offer_carousel',
    path: 'Global/GlobalCategoryProductsCarousel.vue',
    additional: {
      query: 'category',

      handler(arg) {
        return {
          filterBy: [],
          sortBy: 'POPULAR',
          orderBy: 'DEFAULT',
          hash: extractCategoryHash(arg.primary.button_url.url),
          offset: arg.primary.from,
          limit: arg.primary.size,
          enableRating: false
        };
      }

    }
  }, // offer slices
  {
    name: 'offer_inspirations',
    path: 'Offer/OfferInspirations.vue'
  }, {
    name: 'offer_chips',
    path: 'Global/GlobalChips.vue'
  }, {
    name: 'offer_footer',
    path: 'Global/GlobalDispatchFooter.vue'
  }, {
    name: 'offer_header',
    path: 'Offer/OfferHeader.vue'
  }, {
    name: 'collection_banner',
    path: 'Collection/CollectionBanner.vue'
  }, // home deprecated slices
  {
    name: 'home_products',
    path: 'Home/HomeProducts.vue',
    additional: {
      query: 'products',

      handler(arg) {
        return {
          references: arg.items.map(e => e.reference)
        };
      }

    }
  }, {
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',

      handler(arg) {
        return {
          hashes: arg.items.map(e => e.hash)
        };
      }

    }
  }, {
    name: 'home_carousel',
    path: 'Home/HomeCarousel.vue'
  }, {
    name: 'home_block_text',
    path: 'Home/HomeBlockText.vue'
  }, {
    name: 'home_block_battle',
    path: 'Home/HomeBlockBattle.vue'
  }, {
    name: 'home_olapic',
    path: 'Home/HomeOlapic.vue'
  }, {
    name: 'home_sustainable_development',
    path: 'Home/HomeSustainableDevelopment.vue'
  }, {
    name: 'home_newsletter',
    path: 'Home/HomeNewsletter.vue'
  }, {
    name: 'home_block_event',
    path: 'Home/HomeBlockEvent.vue'
  }, // "christmas" deprecated slices
  {
    name: 'christmas_title_line',
    path: 'Christmas/ChristmasTitleLine.vue'
  }, {
    name: 'christmas_inspirations',
    path: 'Christmas/ChristmasInspirations.vue'
  }, {
    name: 'christmas_cards_banner',
    path: 'Christmas/ChristmasCardsBanner.vue'
  }, {
    name: 'christmas_information',
    path: 'Christmas/ChristmasInformation.vue'
  }, {
    name: 'christmas_header_video',
    path: 'Christmas/ChristmasHeaderVideo.vue'
  }, {
    name: 'collection_styles',
    path: 'Collection/CollectionStyles.vue'
  }, {
    name: 'christmas_price_range',
    path: 'Christmas/ChristmasPriceRange.vue'
  }, {
    name: 'christmas_teaser',
    path: 'Christmas/ChristmasTeaser.vue'
  }, {
    name: 'christmas_destocking_banner',
    path: 'Christmas/ChristmasDestockingBanner.vue'
  }, // "range" slices
  {
    name: 'global_range',
    path: 'Global/Range.vue',
    additional: {
      query: 'productPrices',

      handler(arg) {
        return {
          references: arg.items.map(e => e.reference)
        };
      }

    }
  }, {
    name: 'field_section',
    path: 'Global/FieldSection.vue'
  }, {
    name: 'rebounds',
    path: 'Global/Rebounds.vue'
  }, {
    name: 'dispatch_pair_columns',
    path: 'Global/DispatchPairColumns.vue'
  }, {
    name: 'large_image',
    path: 'Global/LargeImage.vue'
  }, {
    name: 'simple_header_no_background',
    path: 'SimpleHeaderNoBackground.vue'
  }, {
    name: 'display_product_slider',
    path: 'DisplayProductSlider.vue'
  }, {
    name: 'presentation_news',
    path: 'PresentationNews.vue'
  }, {
    name: 'customizable_form',
    path: 'Generic/CustomizableForm.vue'
  }, {
    name: 'simple_header_background',
    path: 'SimpleHeaderBackground.vue'
  }, {
    name: 'simple_header_cropped_image',
    path: 'Generic/SimpleHeaderCroppedImage.vue'
  }, {
    name: 'animated_foreground_block',
    path: 'Global/AnimatedForegroundBlock.vue'
  }, {
    name: 'store_chooser',
    path: 'Specific/Clicrdv/StoreChooser.vue'
  }, {
    name: 'contact_pro',
    path: 'Pro/contactForm.vue'
  }, {
    name: 'reassurance_footer_pro',
    path: 'Pro/ReassuranceCards.vue'
  }, // Earlybirds products
  {
    name: 'eb_products_carousel',
    path: 'Global/ProductsCarouselEb.vue'
  }, {
    name: 'announcement_banner',
    path: 'Global/AnnouncementBanner.vue'
  }]
};